import React from "react";
import { Container, Typography, Paper, Card, Box } from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { Link } from "react-router-dom";
import PageIntro from "../components/pageintro";
import ServicesGridCards from "../components/servicesgrid";
import WhyTecloqCards from "../components/whytecloqcards";
import Technologies from "../components/technologies";


const whyTecloq = [
    {
      src: "/assets/BigData/image1.png",
      alt: "why1",
      title: "Empowering Business Transformation",
      description:
        "Tecloq isn't just another tech-driven company. Our data engineering practice is dedicated to driving tangible outcomes, focusing on building robust data models that deliver lasting business value beyond defined use cases.",
    },
    {
      src: "/assets/BigData/image3.png",
      alt: "why1",
      title: "Accelerated Insights Delivery",
      description:
        "With our cutting-edge suite of accelerators, Tecloq’s data engineering solutions slash time-to-value by an impressive 30% compared to traditional consulting and technology service firms. Get the insights you need faster and stay ahead in today's competitive landscape.",
    },
    {
      src: "/assets/BigData/image2.png",
      alt: "why1",
      title: "Harnessing the Power of Open Source",
      description:
        "Embracing the potential of open-source technology, our data engineering team enables accurate real-time analysis of massive data volumes while simultaneously reducing data storage costs. Collaborate effortlessly across diverse fields and maximize efficiency with our open-source approach.",
    },
  ];
  

const offeringdata = [
    {
      "src": "/assets/BigData/DataIntegration/image1.png",
      "alt": "text analysis",
      "width": "65%",
      "paddingTop": "10%",
      "text": "Data Integration Consulting"
    },
    {
      "src": "/assets/BigData/DataIntegration/image2.png",
      "alt": "text analysis",
      "width": "65%",
      "paddingTop": "10%",
      "text": "Streamlined Data Pipelines"
    },
    {
      "src": "/assets/BigData/DataIntegration/image3.png",
      "alt": "text analysis",
      "width": "65%",
      "paddingTop": "10%",
      "text": "Transform Raw Data"
    },
    {
      "src": "/assets/BigData/DataIntegration/image4.png",
      "alt": "text analysis",
      "width": "65%",
      "paddingTop": "10%",
      "text": "Elevate Data Quality"
    },
    {
      "src": "/assets/BigData/DataIntegration/image5.png",
      "alt": "text analysis",
      "width": "65%",
      "paddingTop": "5%",
      "text": "Real-time Insights"
    },
    {
      "src": "/assets/BigData/DataIntegration/image6.png",
      "alt": "text analysis",
      "width": "65%",
      "paddingTop": "0%",
      "text": "Next-level ETL Frameworks"
    }
  ]
  

const DataIntegration = () => {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", overflowX: "hidden" }}>
      <PageIntro
        bg={"/assets/BigData/DataIntegration/banner.webp"}
        subheading={"Catalyzing Growth via Integrated Data Insights"}
        heading={"Data Integration Consulting"}
        desc={"Offering Seamless Integration, Limitless Intelligence"}
      />

      <Box
        sx={{
          maxWidth: "100% !important",
          height: "auto",
          marginTop: { xs: "4%", md: "8%" }, // Adjust margin for smaller screens
          paddingX: { xs: "4%", md: "0" }, // Add padding on small screens to avoid edge cuts
        }}
      >
        <Typography
          sx={{
            fontFamily: "Orbitron",
            fontWeight: "800",
            fontSize: { xs: "24px", sm: "32px", md: "40px" }, // Adjust font size for different screen sizes
            color: "#000000",
            lineHeight: "120%",
            letterSpacing: "2%",
            display: "flex",
            justifyContent: "center",
            paddingBottom: { xs: "2%", md: "4%" }, // Adjust padding for different screen sizes
            textAlign: "center", // Ensure centered alignment on all screen sizes
          }}
        >
          Seamless Data Integration for Your Business
        </Typography>
        <Typography
          sx={{
            fontFamily: "Inter",
            fontWeight: "lighter",
            fontSize: { xs: "14px", sm: "16px", md: "20px" }, // Adjust font size for different screens
            color: "#000000",
            display: "flex",
            textAlign: "center",
            paddingBottom: { xs: "2%", md: "2%" },
            marginX: { xs: "4%", sm: "8%", md: "11%" }, // Adjust margins based on screen size
          }}
        >
          Tecloq’s data integration service turns your data into a strategic
          asset. Our expert team of data integration consultants harnesses
          cutting-edge technologies and tools to seamlessly integrate diverse
          data sources, empowering you with actionable insights. Experience the
          power of robust data pipelines that efficiently gather, transform, and
          load data into your warehouse, enabling data-driven decision-making.
          We prioritize data quality, implementing standards and effective
          cleansing techniques for accurate and reliable information. Real-time
          analytics through streaming data pipelines give you a competitive edge
          by understanding customer behavior instantly. Partner with us to
          discover your data’s true potential and drive exponential business
          growth.
        </Typography>
      </Box>

      <Box
  sx={{
    maxWidth: "100% !important",
    height: "auto",
    marginTop: { xs: "4%", md: "3%" }, // Adjust margin for small screens
    paddingX: { xs: "4%", md: "0" }, // Add horizontal padding on small screens
  }}
>
  <Typography
    sx={{
      fontFamily: "Orbitron",
      fontWeight: "800",
      fontSize: { xs: "24px", sm: "32px", md: "40px" }, // Adjust font size for different screens
      color: "#000000",
      lineHeight: "120%",
      letterSpacing: "2%",
      display: "flex",
      justifyContent: "center",
      paddingBottom: { xs: "2%", md: "1%" }, // Adjust padding for different screen sizes
      textAlign: "center",
    }}
  >
    Our Data Integration Services
  </Typography>
  <Typography
    sx={{
      fontFamily: "Inter",
      fontWeight: "lighter",
      fontSize: { xs: "14px", sm: "16px", md: "20px" }, // Adjust font size for better readability
      color: "#000000",
      display: "flex",
      textAlign: "center",
      paddingBottom: { xs: "3%", md: "2%" },
      marginX: { xs: "4%", sm: "10%", md: "15%" }, // Adjust margins for better centering
    }}
  >
    Discover the true power of data with Tecloq. Our team of data integration consultants redefines transformation, setting you on a path to unrivaled excellence. Elevate your data journey today.
  </Typography>

</Box>
 
  <ServicesGridCards data={offeringdata} />
      {/* <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          flexWrap: "wrap",
          "& > :not(style)": {
            m: 1,
            width: 400,
            height: 340,
          },
          gap: "20px",
        }}
      >
        <Paper
          elevation={3}
          sx={{ borderRadius: "5%", textAlign: "center", paddingTop: "3%" }}
        >
          <img
            src="/assets/BigData/DataIntegration/image1.png"
            alt="text analysis"
            style={{ boxSizing: "border-box", width: "65%", height: "auto" }}
            loading="lazy"
          ></img>
          <Typography
            style={{
              fontFamily: "Inter",
              fontStyle: "normal",
              fontWeight: "700",
              fontSize: "16px",
              lineHeight: "21px",
              alignItems: "center",
              textAlign: "center",
              color: "#000000",
              paddingTop: "10%",
            }}
          >
            Data Integration <br />
            Consulting
          </Typography>
        </Paper>
        <Paper
          elevation={3}
          sx={{ borderRadius: "5%", textAlign: "center", paddingTop: "3%" }}
        >
          <img
            src="/assets/BigData/DataIntegration/image2.png"
            alt="text analysis"
            style={{ boxSizing: "border-box", width: "65%", height: "auto" }}
            loading="lazy"
          ></img>
          <Typography
            style={{
              fontFamily: "Inter",
              fontStyle: "normal",
              fontWeight: "700",
              fontSize: "16px",
              lineHeight: "21px",
              alignItems: "center",
              textAlign: "center",
              color: "#000000",
              paddingTop: "10%",
            }}
          >
            Streamlined Data <br />
            Pipelines
          </Typography>
        </Paper>
        <Paper
          elevation={3}
          sx={{ borderRadius: "5%", textAlign: "center", paddingTop: "3%" }}
        >
          <img
            src="/assets/BigData/DataIntegration/image3.png"
            alt="text analysis"
            style={{ boxSizing: "border-box", width: "65%", height: "auto" }}
            loading="lazy"
          ></img>
          <Typography
            style={{
              fontFamily: "Inter",
              fontStyle: "normal",
              fontWeight: "700",
              fontSize: "16px",
              lineHeight: "21px",
              alignItems: "center",
              textAlign: "center",
              color: "#000000",
              paddingTop: "10%",
            }}
          >
            Transform Raw Data
          </Typography>
        </Paper>
        <Paper
          elevation={3}
          sx={{ borderRadius: "5%", textAlign: "center", paddingTop: "3%" }}
        >
          <img
            src="/assets/BigData/DataIntegration/image4.png"
            alt="text analysis"
            style={{ boxSizing: "border-box", width: "65%", height: "auto" }}
            loading="lazy"
          ></img>
          <Typography
            style={{
              fontFamily: "Inter",
              fontStyle: "normal",
              fontWeight: "700",
              fontSize: "16px",
              lineHeight: "21px",
              alignItems: "center",
              textAlign: "center",
              color: "#000000",
              paddingTop: "10%",
            }}
          >
            Elevate Data <br /> Quality
          </Typography>
        </Paper>
        <Paper
          elevation={3}
          sx={{ borderRadius: "5%", textAlign: "center", paddingTop: "3%" }}
        >
          <img
            src="/assets/BigData/DataIntegration/image5.png"
            alt="text analysis"
            style={{ boxSizing: "border-box", width: "65%", height: "auto" }}
            loading="lazy"
          ></img>
          <Typography
            style={{
              fontFamily: "Inter",
              fontStyle: "normal",
              fontWeight: "700",
              fontSize: "16px",
              lineHeight: "21px",
              alignItems: "center",
              textAlign: "center",
              color: "#000000",
              paddingTop: "5%",
            }}
          >
            Real-time Insights
          </Typography>
        </Paper>
        <Paper
          elevation={3}
          sx={{ borderRadius: "5%", textAlign: "center", paddingTop: "3%" }}
        >
          <img
            src="/assets/BigData/DataIntegration/image6.png"
            alt="text analysis"
            style={{ boxSizing: "border-box", width: "65%", height: "auto" }}
            loading="lazy"
          ></img>
          <Typography
            style={{
              fontFamily: "Inter",
              fontStyle: "normal",
              fontWeight: "700",
              fontSize: "16px",
              lineHeight: "21px",
              alignItems: "center",
              textAlign: "center",
              color: "#000000",
              paddingTop: "0%",
            }}
          >
            Next-level ETL Frameworks
          </Typography>
        </Paper>
      </Box> */}

<Box
  sx={{
    maxWidth: "100%",
    height: "auto",
    marginTop: { xs: "5%", md: "3%" },
  }}
>
  <Typography
    sx={{
      fontFamily: "Orbitron",
      fontWeight: "800",
      fontSize: { xs: "24px", md: "40px" },
      color: "#000000",
      lineHeight: "120%",
      letterSpacing: "2%",
      display: "flex",
      justifyContent: "center",
      paddingBottom: { xs: "2%", md: "1%" },
    }}
  >
    The Process
  </Typography>
  <Typography
    sx={{
      fontFamily: "Inter",
      fontWeight: "lighter",
      fontSize: { xs: "14px", md: "20px" },
      color: "#000000",
      display: "flex",
      justifyContent: "center",
      margin: { xs: "2% 5%", md: "1% 10% 2% 10%" },
      textAlign: "center",
    }}
  >
    With Tecloq, your data journey is seamless and efficient. Our Big Data
    experts utilize data from across the business ecosystem, crafting a
    comprehensive approach that ensures your data delivers meaningful and
    impactful results. Choosing Tecloq as your Data Analytics Services partner
    means embracing a holistic approach to data-driven decision-making. We stand
    out for several reasons.
  </Typography>
</Box>

<Box
  sx={{
    display: "flex",
    flexDirection: "column",
    maxWidth: "100%",
    height: "auto",
    alignItems: "center",
  }}
>
  <img
    src="/assets/BigData/ProcessGIF.gif"
    alt="tech"
    loading="lazy"
    style={{
      width: "100%", // Full width on small screens
      maxWidth: "75%", // Limit size on larger screens
      height: "auto",
      paddingTop: "3%",
    }}
  />
</Box>





<Box
  sx={{
    maxWidth: "100%",
    height: "auto",
    marginTop: { xs: "5%", md: "3%" },
  }}
>
  <Typography
    sx={{
      fontFamily: "Orbitron",
      fontWeight: "800",
      fontSize: { xs: "24px", md: "40px" },
      color: "#000000",
      lineHeight: "120%",
      letterSpacing: "2%",
      display: "flex",
      justifyContent: "center",
      paddingBottom: { xs: "3%", md: "1%" },
    }}
  >
    The Tecloq Advantage
  </Typography>
  <Typography
    sx={{
      fontFamily: "Inter",
      fontWeight: "lighter",
      fontSize: { xs: "14px", md: "20px" },
      color: "#000000",
      display: "flex",
      justifyContent: "center",
      margin: { xs: "2% 5%", md: "1% 10% 2% 10%" },
      textAlign: "center",
    }}
  >
    Partnering with Tecloq gives you access to industry-leading data engineering
    consulting and solutions. Our team's in-depth knowledge and experience allow
    us to tackle complex data challenges and deliver solutions that drive
    tangible results for your business. Our Big Data analytics services enable
    accurate consolidation, management, protection, and understanding of your
    business-aligned data. Here's what sets us apart.
  </Typography>
</Box>


      {/* <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          flexWrap: "wrap",
          "& > :not(style)": {
            m: 1,
            width: 370,
            height: 700,
          },
          gap: "3%",
        }}
      >
        <Paper
          elevation={3}
          sx={{
            borderRadius: "3%",
            textAlign: "center",
            border: "0.5px solid #FFC3EA",
            alignContent: "center",
            boxShadow: "0px -3px 17px rgba(240, 5, 162, 0.52)",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <img
            src="/assets/BigData/image1.png"
            loading="lazy"
            alt="why1"
            style={{
              width: "70%",
              height: "35%",
              padding: "15% 0px 10% 15%",
            }}
          ></img>
          <Typography
            sx={{
              fontFamily: "Orbitron",
              lineHeight: "120%",
              fontSize: "28px",
              fontStyle: "normal",
              fontWeight: "700",
              color: "#F005A2",
              letterSpacing: "2%",
            }}
          >
            Empowering Business <br />
            Transformation
          </Typography>
          <Typography
            sx={{
              fontFamily: "Inter",
              fontStyle: "normal",
              lineHeight: "auto",
              padding: "10% 15% 3% 15%",
              textAlign: "center",
            }}
          >
            Tecloq isn't just another tech-driven company. Our data engineering
            practice is dedicated to driving tangible outcomes, focusing on
            building robust data models that deliver lasting business value
            beyond defined use cases.
          </Typography>
        </Paper>
        <Paper
          elevation={3}
          sx={{
            borderRadius: "3%",
            textAlign: "center",
            border: "0.5px solid #FFC3EA",
            alignContent: "center",
            boxShadow: "0px -3px 17px rgba(240, 5, 162, 0.52)",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <img
            src="/assets/BigData/image3.png"
            alt="why1"
            loading="lazy"
            style={{
              width: "70%",
              height: "35%",
              padding: "15% 0px 10% 15%",
            }}
          ></img>
          <Typography
            sx={{
              fontFamily: "Orbitron",
              lineHeight: "120%",
              fontSize: "28px",
              fontStyle: "normal",
              fontWeight: "700",
              color: "#F005A2",
              letterSpacing: "2%",
            }}
          >
            Accelerated Insights <br />
            Delivery
          </Typography>
          <Typography
            sx={{
              fontFamily: "Inter",
              fontStyle: "normal",
              lineHeight: "auto",
              padding: "10% 15% 3% 15%",
              textAlign: "center",
            }}
          >
            With our cutting-edge suite of accelerators, Tecloq’s data
            engineering solutions slash time-to- value by an impressive 30%
            compared to traditional consulting and technology service firms. Get
            the insights you need faster and stay ahead in today's competitive
            landscape.
          </Typography>
        </Paper>
        <Paper
          elevation={3}
          sx={{
            borderRadius: "3%",
            textAlign: "center",
            border: "0.5px solid #FFC3EA",
            alignContent: "center",
            boxShadow: "0px -3px 17px rgba(240, 5, 162, 0.52)",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <img
            src="/assets/BigData/image2.png"
            alt="why1"
            loading="lazy"
            style={{
              width: "70%",
              height: "35%",
              padding: "15% 0px 10% 15%",
            }}
          ></img>
          <Typography
            sx={{
              fontFamily: "Orbitron",
              lineHeight: "120%",
              fontSize: "28px",
              fontStyle: "normal",
              fontWeight: "700",
              color: "#F005A2",
              letterSpacing: "2%",
            }}
          >
            Harnessing the Power <br />
            of Open Source
          </Typography>
          <Typography
            sx={{
              fontFamily: "Inter",
              fontStyle: "normal",
              lineHeight: "auto",
              padding: "10% 15% 3% 15%",
              textAlign: "center",
            }}
          >
            Embracing the potential of open-source technology. our data
            engineering team enables accurate real-time analysis of massive data
            volumes. while simultaneously reducing data storage costs.
            Collaborate effortlessly across diverse fields and maximize
            efficiency with our open-source approach.
          </Typography>
        </Paper>
      </Box> */}

      <WhyTecloqCards data={whyTecloq} />
      
      <Technologies />
    </Box>
  );
};

export default DataIntegration;
